import React, { useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { Icon } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';
import { useOrder } from 'hooks/useOrders';
import { formatters as dateFormatters } from 'utils/dateAndTimes';
import { joinElementsWithSeparatorAndEndingSeparator } from 'utils/array';
import { getFirstDate } from 'utils/recurringOrder/recurringOrderUtils';

const Header = ({ className, orderId }) => {
  const { t } = useTranslation('Recurring');
  const { order } = useOrder(orderId, true);

  const title = useMemo(() => {
    const daysJoined = joinElementsWithSeparatorAndEndingSeparator(
      order.schedule?.sort().map((d) => t(`weekdays_plural.${d}`)),
      ', ',
      t('and')
    );
    return `${t('summary.repeat')} ${daysJoined}`;
  }, [order.schedule, t]);

  const infoText = useMemo(() => {
    const start = dateFormatters.getHumanReadableFormattedDate({
      value: order.start_from,
      t,
    });
    const end = dateFormatters.getHumanReadableFormattedDate({
      value: order.end_on,
      t,
    });
    const firstDate = getFirstDate({
      days: order.schedule,
      fromDate: order.start_from,
    });
    const first = dateFormatters.getHumanReadableFormattedDate({
      value: firstDate,
      t,
    });
    return `${t('summary.from_to', { start, end })} ${t('summary.first', {
      first,
    })}.`;
  }, [order, t]);

  return (
    <div className={className}>
      <div className="icon-container">
        <Icon glyph="recurring" size="48px" color="grey700" />
      </div>
      <div>
        <h1>{title}</h1>
        <p>{infoText}</p>
        <p>{t('summary.holidays_info')}</p>
      </div>
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  orderId: PropTypes.string.isRequired,
};

export default Header;
